module.exports = __webpack_public_path__ + "static/img/btn-buygift-top.adf3f48c.gif";